import { useState } from 'react';

const useAlert = () => {
  const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

  const showAlert = (message, variant = 'success') => {
    setAlert({ show: true, message, variant });
    setTimeout(() => setAlert({ show: false, message: '', variant }), 2000);  // Auto-hide after 3s
  };

  return { alert, showAlert };
};

export default useAlert;